// extracted by mini-css-extract-plugin
export const wrapper = "start-trial-module--wrapper--2Dggw";
export const floatingFreeTrial = "start-trial-module--floating-free-trial--30E4T";
export const buttonContainer = "start-trial-module--button-container--2nnjt";
export const freeTrialButton = "start-trial-module--free-trial-button--3tcQ-";
export const textContent = "start-trial-module--text-content--3bOrd";
export const buttonClose = "start-trial-module--button-close--3XuZa";